import {Helmet} from "react-helmet";

export function CustomMetaHelmet({meta}) {
    const title = meta?.title;
    const description = meta?.description;
    const ogTitle = meta?.og_title;
    const ogDescription = meta?.og_description;
    const ogImage = meta?.og_image;
    const ogImageWidth = meta?.og_image_width;
    const ogImageHeight = meta?.og_image_height;

    return (
        <Helmet>
            <title>
                {title}
            </title>
            <meta
                name="title"
                content={title}
            />
            <meta
                name="description"
                content={description}
            />
            <meta
                property="og:title"
                content={ogTitle}
            />
            <meta
                property="og:description"
                content={ogDescription}
            />
            <meta
                property="og:image"
                content={ogImage}
            />
            <meta
                property="og:image:width"
                content={ogImageWidth}
            />
            <meta
                property="og:image:height"
                content={ogImageHeight}
            />
        </Helmet>
    );
}
